import {
  FIREBASE_CONNECTED,
  FIREBASE_DISCONNECTED,
  FIREBASE_AUTHENTICATED,
  FIREBASE_UNAUTHENTICATED,
} from '@app/actions/firebase';

const initialState = {
  connected: false,
  connectedAtLeastOnce: false,
  previousConnectionStatusChangeAt: Date.now(),
  authenticated: undefined,
};

const firebase = (state = initialState, action) => {
  switch (action.type) {
    case FIREBASE_CONNECTED:
      if (state.connected) {
        return state;
      }
      return {
        ...state,
        connected: true,
        connectedAtLeastOnce: true,
        previousConnectionStatusChangeAt: Date.now(),
      };
    case FIREBASE_DISCONNECTED:
      if (!state.connected) {
        return state;
      }
      return {
        ...state,
        connected: false,
        previousConnectionStatusChangeAt: Date.now(),
      };
    case FIREBASE_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
        uid: action.uid,
      };
    case FIREBASE_UNAUTHENTICATED:
      return {
        ...state,
        authenticated: false,
        uid: undefined,
      };
    default:
      return state;
  }
};

export default firebase;



// WEBPACK FOOTER //
// ./src/reducer/firebase.js